<template>
  <div id="app">
    <div class="main-content">
      <router-view/>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/footer/Footer';

export default {
  name: 'App',
  components: {
    Footer,
  },
};
</script>

<style lang="scss" scoped>
  #app {
    background-color: #EEEEEE;

    div.main-content {
      min-height: calc(100vh - 2rem);
    }
  }
</style>




// WEBPACK FOOTER //
// src/App.vue